import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    /**
     * Per la massima compatibilità con tutti i dispositivi mobili e non
     * vengono utilizzate 2 tipologie di funzione per eseguire lo scroll
     */
    window.addEventListener('load', () => {
      window.scrollTo(0, -60);
    });
    /**
     * In questo caso lo scroll viene eseguito 3 volte.
     * A tempo 0, 200 e 400 in tal modo si esegue immediatamente
     * e anche successivamente, nel caso vengano renderizzati dei
     * compenti dopo un breve ritardo.
     */
    for (let i = 0; i < 3; ++i) {
      setTimeout(() => {
        window.scrollTo(0, -60)
      }, 200 * i);
    }
  }, [pathname]);

  return null;
}